import { Link, Navigate } from 'react-router-dom';
import { usePainelMe } from '@/components/painel/PainelContext';

/** `/painel`: com uma org vai direto; com várias, escolhe. */
export default function PainelHome() {
  const me = usePainelMe();
  if (me.orgs.length === 1) return <Navigate to={`/painel/${me.orgs[0]!.id}`} replace />;
  return (
    <div className="pt-2">
      <h2 className="m-0 text-[20px] font-semibold tracking-[-0.02em]">Escolha a organização</h2>
      <ul className="m-0 mt-4 flex list-none flex-col gap-2 p-0">
        {me.orgs.map((o) => (
          <li key={o.id}>
            <Link
              to={`/painel/${o.id}`}
              className="flex items-center justify-between rounded-2xl bg-white px-4 py-4 text-[15px] font-semibold shadow-soft"
            >
              {o.name}
              <span className="text-[12.5px] font-medium text-bow-royal/55">
                {o.kind === 'cpo' ? 'Operador' : 'Investidor'}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
